import React from "react";
import { Tabs } from "antd";

import UploadPickupReport from "./uploadPickupReport";
import UploadSalesReport from "./uploadSalesReport";
import DeleteUploadData from "./deleteUploadData";

const items = [
	{
		key: "1",
		label: "Upload Pickup Report",
		children: <UploadPickupReport />,
	},
	{
		key: "2",
		label: "Upload Sales Report",
		children: <UploadSalesReport />,
	},
	{
		key: "3",
		label: "Delete Upload Data by Date",
		children: <DeleteUploadData />,
	},
];

const UploadPage = () => {
	return <Tabs defaultActiveKey="1" items={items} />;
};
export default UploadPage;
